module.exports = __webpack_public_path__ + "img/follow.0828bbad.png";